/**
 * Reading a customer address back as one line.
 *
 * The shop writes an address the way it would write it on a box — one block of
 * text, because that is how somebody says where they live and how a rider
 * reads it. `line1` holds that block.
 *
 * The separate barangay, city, province and postcode columns are older: the
 * form used to ask for each one in its own box. Records created that way still
 * carry them, so they are appended when present. Nothing writes them any more,
 * and the columns are left alone rather than being migrated away — a rebuild
 * of `customer_addresses` would clear `orders.address_id` on every order ever
 * delivered, which is a real cost for a tidier schema.
 */
export function formatAddress(address) {
    const line1 = address.line1?.trim() ?? '';
    const haystack = line1.toLowerCase();
    /*
     * A part `line1` already names is dropped rather than repeated.
     *
     * The old form asked for the city separately *and* people wrote it into the
     * street line anyway — of the shop's addresses that carry a separate part,
     * every single one already names it. Appending it blindly gives "845 Arnaiz
     * Avenue Makati City, Makati".
     */
    const extras = [address.barangay, address.city, address.province, address.postalCode]
        .map((part) => part?.trim())
        .filter((part) => Boolean(part))
        .filter((part) => !haystack.includes(part.toLowerCase()));
    const line = [line1, ...extras].filter(Boolean).join(', ');
    // A landmark is a direction, not part of the address, so it reads after it.
    const landmark = address.landmark?.trim();
    return landmark && !haystack.includes(landmark.toLowerCase()) ? `${line} (${landmark})` : line;
}
//# sourceMappingURL=addresses.js.map